export default "__VITE_ASSET__WECoLkQ3__"